import styled from 'styled-components'

export const ButtonWrap = styled.div``

export const DetailsContainer = styled.div`
  padding: 16px;
  border-radius: 12px;
  background: var(--t-surface-2);
`
